// /* eslint-disable camelcase */
/* eslint-disable max-len */
import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { renderToString } from 'react-dom/server';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import aarsXpoLogo from '../../assets/images/aars_xpo.png';
import adventureXpoLogo from '../../assets/images/adventure_xpo.png';
import europeXpoLogo from '../../assets/images/europe_xpo.png';
import familyXpoLogo from '../../assets/images/family_xpo.png';
import luxuryXpoLogo from '../../assets/images/luxury_xpo.png';
import romanceXpoLogo from '../../assets/images/romance_xpo.png';
import xpoProTravPro from '../../assets/images/xpo-pro_and_trav-pro.png';
import { APIHandler, BackVideo, FeaturedShowItem, SharingPopup, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

class HomeView extends Component {
  constructor() {
    super();
    this.state = {
      activeHeaderItemIndex: 0,
      events: {},
      upcomingEvents: [],
      showsToSignUp: ['luxury', 'romance', 'europe', 'family', 'aars', 'adventure'],
    };

    this.getEvents = this.getEvents.bind(this);
    this.goToSignUp = this.goToSignUp.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.checkDateInPast = (firstDate, secondDate) => {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
  }

  async componentDidMount() {
    await this.getEvents();
    StorageHandler.remove(storageKeys.showsToSignUp);
    this.sortEvents();
    window.onscroll = () => {
      if (document.getElementById('home-nav')) {
        if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
          document.getElementById('home-nav').className = 'nav-scrolled';
        } else {
          document.getElementById('home-nav').className = 'nav';
        }
      }
    };
  }

  async getEvents() {
    await APIHandler.getEvents().then((res) => {
      if (res) {
        const eventsArray = Object.values(res);
        if (eventsArray && eventsArray[0] && eventsArray[0][0]) {
          this.setState({
            events: eventsArray[0][0],
          });
        }
      }
    });
  }

  sortEvents() {
    const { events } = this.state;
    const upcomingEventsArray = [];
    const previousEventsArray = [];
    if (events) {
      events.forEach((item) => {
        // if (item.start_date !== '0000-00-00 00:00:00') {
        //   const eventDate = new Date(item.start_date);
        //   const today = new Date();
        //   if (this.checkDateInPast(eventDate, today) === true) {
        //     previousEventsArray.push(item);
        //   } else {
        //     upcomingEventsArray.push(item);
        //   }
        // }
        // if (item.id === 803) {
        //   upcomingEventsArray.push(item);
        // }
        if (item.id === 1668) {
          upcomingEventsArray.push(item);
        }
        if (item.id === 1678) {
          upcomingEventsArray.push(item);
        }
        if (item.id === 1680) {
          upcomingEventsArray.push(item);
        }
        if (item.id === 1681) {
          upcomingEventsArray.push(item);
        }
      });

      if (upcomingEventsArray.length > 0) {
        upcomingEventsArray.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      }
      this.setState({
        upcomingEvents: upcomingEventsArray,
      });
    }
  }

  async goToSignUp(show) {
    const { showsToSignUp } = this.state;
    const showsArray = [];

    if (show === undefined) {
      await StorageHandler.save(storageKeys.showsToSignUp, showsToSignUp);
      window.location.href = '/attendee';
    } else {
      showsArray.push(show);
      await StorageHandler.save(storageKeys.showsToSignUp, showsArray);
      window.location.href = '/attendee';
    }
  }

  handleChange() {
    const { id } = event.target;
    const { showsToSignUp } = this.state;
    const showsArray = showsToSignUp;

    if (showsArray.length > 0 && showsArray.includes(id)) {
      const index = showsArray.indexOf(id);
      if (index > -1) {
        showsArray.splice(index, 1);
      }
      this.setState({ showsToSignUp: showsArray });
      return;
    }

    showsArray.push(id);
    this.setState({ showsToSignUp: showsArray });
  }

  render() {
    const { activeHeaderItemIndex, showsToSignUp, upcomingEvents } = this.state;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['share', 'close'],
      share: {
        tpl: renderToString(
          <SharingPopup url="https://front.travpromobile.com/848/XpoPRO2024-price-sheet.pdf" />,
        ),
      },
    };

    const importAll = (r) => {
      const images = {};
      r.keys().forEach((item, index) => {
        images[item.replace('./', '')] = r(item);
      });
      return images;
    };

    const destinations = importAll(
      require.context('../../assets/images/destinations', false, /\.(png|jpg)$/),
    );
    const suppliers = importAll(
      require.context('../../assets/images/suppliers', false, /\.(png|jpg)$/),
    );

    const sliderSettings = {
      dots: false,
      infinite: true,
      autoplay: true,
      draggable: true,
      autoplaySpeed: 2000,
      adaptiveHeight: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    return (
      <div className="home">
        <nav id="home-nav" className="nav">
          <div className="nav__content">
            <div className="nav__image">
              <h1>{'VIRTUAL TRAVEL XPOS'}</h1>
            </div>
            <a
              data-fancybox="price-sheet"
              data-type="iframe"
              href="https://front.travpromobile.com/848/XpoPRO2024-price-sheet.pdf"
              data-options={JSON.stringify(fancyOptions)}
              data-url="https://front.travpromobile.com/848/XpoPRO2024-price-sheet.pdf"
            >
              {'Exhibitor Information'}
            </a>
          </div>
        </nav>
        <div className="home__header">
          <div className="home__header--container">
            <div className="title">
              <BackVideo />
            </div>
            <div
              className="headerItems"
              onMouseLeave={() => {
                this.setState({ activeHeaderItemIndex: 0 });
              }}
            >
              {upcomingEvents.slice(-4).map((item, i) => {
                const key = i;
                return (
                  <div
                    key={key}
                    className={`headerItem ${i === activeHeaderItemIndex ? 'active' : ''}`}
                    onMouseOver={() => {
                      this.setState({ activeHeaderItemIndex: i });
                    }}
                    onFocus={() => {
                      this.setState({ activeHeaderItemIndex: i });
                    }}
                  >
                    <FeaturedShowItem
                      showData={item}
                      activatePopup={this.activatePopup}
                      handleRegisterButton={this.handleRegisterButton}
                      goToSignUp={this.goToSignUp}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="home__header--scrollDown">
            <FontAwesomeIcon icon="chevron-down" />
          </div>
        </div>

        <section className="home__intro">
          <div
            className="section__image"
            style={{
              backgroundImage: 'url(https://travprocdn.imgix.net/848/AdventureXpo.png?width=600)',
            }}
          />
          <div className="section__text">
            <div className="title">
              <h1>
                {
                  'Easily connect with exhibitors from the comfort of your home, your office or anywhere in the world!'
                }
              </h1>
            </div>
            <p>
              {
                'Sign up for the best virtual travel events for advisors eager to learn, have fun and connect with destinations and suppliers, already adopted and loved by over 4,000 advisors.'
              }
            </p>
            <p className="sidenote">
              {
                "*WARNING:  You may find that you are not bored by attending our events, so you may need to schedule separate time to do other things like folding laundry, making dinner, checking emails or helping your kids on zoom. Unlike many other virtual events you may have attended in the past couple of years, our events don't suck."
              }
            </p>
            <button type="button" onClick={() => this.goToSignUp()} className="btn">
              {'Sign up now'}
            </button>
          </div>
        </section>

        <div className="section__background">
          <section className="home__signup">
            <div className="title">
              <h1>{'Select your Xpo(s) and sign up now!'}</h1>
              <hr className="shortLine" />
            </div>
            <div className="home__signup--grid">
              <div className="signup__item">
                <div onClick={() => this.goToSignUp('family')}>
                  <img src={familyXpoLogo} alt="Family Travel Xpo" />
                </div>
                <div className="signup__item--checkbox">
                  <label htmlFor="family">
                    <input
                      type="checkbox"
                      id="family"
                      onChange={this.handleChange}
                      checked={showsToSignUp.length > 0 && showsToSignUp.includes('family')}
                    />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Family Travel Xpo'}</strong>
                      <br />
                      {'Mar 26'}
                    </span>
                  </label>
                </div>
              </div>
              <div className="signup__item">
                <div onClick={() => this.goToSignUp('luxury')}>
                  <img src={luxuryXpoLogo} alt="Luxury Travel Xpo" />
                </div>
                <div className="signup__item--checkbox">
                  <label htmlFor="luxury">
                    <input
                      type="checkbox"
                      id="luxury"
                      onChange={this.handleChange}
                      checked={showsToSignUp.length > 0 && showsToSignUp.includes('luxury')}
                    />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Luxury Travel Xpo'}</strong>
                      <br />
                      {'May 7'}
                    </span>
                  </label>
                </div>
              </div>
              <div className="signup__item">
                <div onClick={() => this.goToSignUp('adventure')}>
                  <img src={adventureXpoLogo} alt="Adventure Travel Xpo" />
                </div>
                <div className="signup__item--checkbox">
                  <label htmlFor="adventure">
                    <input
                      type="checkbox"
                      id="adventure"
                      onChange={this.handleChange}
                      checked={showsToSignUp.length > 0 && showsToSignUp.includes('adventure')}
                    />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Adventure Travel Xpo'}</strong>
                      <br />
                      {'Sep 23'}
                    </span>
                  </label>
                </div>
              </div>
              <div className="signup__item">
                <div onClick={() => this.goToSignUp('romance')}>
                  <img src={romanceXpoLogo} alt="Romance Travel Xpo" />
                </div>
                <div className="signup__item--checkbox">
                  <label htmlFor="romance">
                    <input
                      type="checkbox"
                      id="romance"
                      onChange={this.handleChange}
                      checked={showsToSignUp.length > 0 && showsToSignUp.includes('romance')}
                    />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Romance Travel Xpo'}</strong>
                      <br />
                      {'Nov 4'}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <h2>
              {'$1,000 in gift card giveaways'}
              <br />
              <br />
              {'plus additional prizes from exhibitors'}
            </h2>

            <button type="button" onClick={() => this.goToSignUp()} className="btn">
              {'Sign up now'}
            </button>
          </section>
        </div>

        <section className="home__whyjoin">
          <div className="section__text">
            <div className="title">
              <h1>{'Why join?'}</h1>
              <hr className="shortLine" />
            </div>
            <p>
              {
                'Each Xpo is free for travel advisors to attend and includes valuable breakout sessions, an exhibition floor, in-depth trainings, a network lounge and prize giveaways! All the content and exhibitor showcases can be shared directly with clients on social media or via email.'
              }
            </p>
            <p>
              {'All Xpos will feature Live Chats with exhibitors from '}
              <strong>{'12p - 4p (ET) / 9a - 1p (PT)'}</strong>
              {' on the event date and will then be accessible '}
              <strong>{'on-demand for 30 days'}</strong>
              {', so you can visit revisit the event on your own time.'}
            </p>
          </div>
          <div
            className="section__image"
            style={{
              backgroundImage: 'url(https://travprocdn.imgix.net/848/FamilyXpo.png?width=600)',
            }}
          />
        </section>

        <div className="section__background">
          <section className="home__testimonials">
            <div className="title">
              <h1>{'Testimonials'}</h1>
              <hr className="shortLine" />
            </div>
            <div className="home__testimonials--grid">
              <div className="home__testimonials--item">
                <p>
                  {
                    "“This has been such a great event, and honestly one of the best online event platforms I've experienced. Really happy to get to catch up & meet some new people from the travel industry today.”"
                  }
                </p>
                <strong>{'Romance Travel Xpo - Apr, 2025'}</strong>
              </div>
              <div className="home__testimonials--item">
                <p>
                  {'“Love this platform…much better than several others who do the same thing!”'}
                </p>
                <strong>{'Family Travel Xpo - May, 2025'}</strong>
              </div>
              <div className="home__testimonials--item">
                <p>
                  {
                    "“This has been one of the best virtual expos I've attended. The shareable photos and videos are outstanding and are making my job much easier - thank you all!”"
                  }
                </p>
                <strong>{'Luxury Travel Xpo - Jul, 2025'}</strong>
              </div>
            </div>
          </section>
        </div>

        <section className="home__industry">
          <div className="title">
            <h1>{"We work with the industry's best"}</h1>
            <hr className="shortLine" />
          </div>
          <div className="home__industry--slider">
            <Slider {...sliderSettings}>
              {Object.values(destinations).map((image, key) => (
                <div key={key} className="sliderdiv">
                  <img src={image} alt="" />
                </div>
              ))}
            </Slider>
          </div>
          <div className="home__industry--slider">
            <Slider {...sliderSettings}>
              {Object.values(suppliers).map((image, key) => (
                <div key={key} className="sliderdiv">
                  <img src={image} alt="" />
                </div>
              ))}
            </Slider>
          </div>
        </section>

        <hr />

        <section className="home__xpoPro-travPro">
          <img src={xpoProTravPro} alt="" />
        </section>
      </div>
    );
  }
}

export default HomeView;
